/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddOptionCommandResult } from '../models/add-option-command-result';
import { apiKpIsAddOptionPost } from '../fn/project-categories-kp-is/api-kp-is-add-option-post';
import { ApiKpIsAddOptionPost$Params } from '../fn/project-categories-kp-is/api-kp-is-add-option-post';
import { apiKpIsAddOptionPost$Plain } from '../fn/project-categories-kp-is/api-kp-is-add-option-post-plain';
import { ApiKpIsAddOptionPost$Plain$Params } from '../fn/project-categories-kp-is/api-kp-is-add-option-post-plain';
import { apiKpIsCreateKpiPost } from '../fn/project-categories-kp-is/api-kp-is-create-kpi-post';
import { ApiKpIsCreateKpiPost$Params } from '../fn/project-categories-kp-is/api-kp-is-create-kpi-post';
import { apiKpIsCreateKpiPost$Plain } from '../fn/project-categories-kp-is/api-kp-is-create-kpi-post-plain';
import { ApiKpIsCreateKpiPost$Plain$Params } from '../fn/project-categories-kp-is/api-kp-is-create-kpi-post-plain';
import { apiKpIsCreateKpIsFromExcelSheetPost } from '../fn/project-categories-kp-is/api-kp-is-create-kp-is-from-excel-sheet-post';
import { ApiKpIsCreateKpIsFromExcelSheetPost$Params } from '../fn/project-categories-kp-is/api-kp-is-create-kp-is-from-excel-sheet-post';
import { apiKpIsCreateKpIsFromExcelSheetPost$Plain } from '../fn/project-categories-kp-is/api-kp-is-create-kp-is-from-excel-sheet-post-plain';
import { ApiKpIsCreateKpIsFromExcelSheetPost$Plain$Params } from '../fn/project-categories-kp-is/api-kp-is-create-kp-is-from-excel-sheet-post-plain';
import { apiKpIsDeleteKpiDelete } from '../fn/project-categories-kp-is/api-kp-is-delete-kpi-delete';
import { ApiKpIsDeleteKpiDelete$Params } from '../fn/project-categories-kp-is/api-kp-is-delete-kpi-delete';
import { apiKpIsDeleteKpiDelete$Plain } from '../fn/project-categories-kp-is/api-kp-is-delete-kpi-delete-plain';
import { ApiKpIsDeleteKpiDelete$Plain$Params } from '../fn/project-categories-kp-is/api-kp-is-delete-kpi-delete-plain';
import { apiKpIsDeleteOptionDelete } from '../fn/project-categories-kp-is/api-kp-is-delete-option-delete';
import { ApiKpIsDeleteOptionDelete$Params } from '../fn/project-categories-kp-is/api-kp-is-delete-option-delete';
import { apiKpIsDeleteOptionDelete$Plain } from '../fn/project-categories-kp-is/api-kp-is-delete-option-delete-plain';
import { ApiKpIsDeleteOptionDelete$Plain$Params } from '../fn/project-categories-kp-is/api-kp-is-delete-option-delete-plain';
import { apiKpIsGetKpIsPost } from '../fn/project-categories-kp-is/api-kp-is-get-kp-is-post';
import { ApiKpIsGetKpIsPost$Params } from '../fn/project-categories-kp-is/api-kp-is-get-kp-is-post';
import { apiKpIsGetKpIsPost$Plain } from '../fn/project-categories-kp-is/api-kp-is-get-kp-is-post-plain';
import { ApiKpIsGetKpIsPost$Plain$Params } from '../fn/project-categories-kp-is/api-kp-is-get-kp-is-post-plain';
import { apiKpIsUpdateKpiPut } from '../fn/project-categories-kp-is/api-kp-is-update-kpi-put';
import { ApiKpIsUpdateKpiPut$Params } from '../fn/project-categories-kp-is/api-kp-is-update-kpi-put';
import { apiKpIsUpdateKpiPut$Plain } from '../fn/project-categories-kp-is/api-kp-is-update-kpi-put-plain';
import { ApiKpIsUpdateKpiPut$Plain$Params } from '../fn/project-categories-kp-is/api-kp-is-update-kpi-put-plain';
import { BaseCommandResult } from '../models/base-command-result';
import { CreateKpiCommandResult } from '../models/create-kpi-command-result';
import { CreateKpIsFromExcelSheetResult } from '../models/create-kp-is-from-excel-sheet-result';
import { DeleteOptionCommandResult } from '../models/delete-option-command-result';
import { GetKpIsQueryResult } from '../models/get-kp-is-query-result';

@Injectable({ providedIn: 'root' })
export class ProjectCategoriesKpIsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiKpIsCreateKpiPost()` */
  static readonly ApiKpIsCreateKpiPostPath = '/api/KPIs/CreateKPI';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsCreateKpiPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsCreateKpiPost$Plain$Response(params?: ApiKpIsCreateKpiPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateKpiCommandResult>> {
    return apiKpIsCreateKpiPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsCreateKpiPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsCreateKpiPost$Plain(params?: ApiKpIsCreateKpiPost$Plain$Params, context?: HttpContext): Observable<CreateKpiCommandResult> {
    return this.apiKpIsCreateKpiPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateKpiCommandResult>): CreateKpiCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsCreateKpiPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsCreateKpiPost$Response(params?: ApiKpIsCreateKpiPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateKpiCommandResult>> {
    return apiKpIsCreateKpiPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsCreateKpiPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsCreateKpiPost(params?: ApiKpIsCreateKpiPost$Params, context?: HttpContext): Observable<CreateKpiCommandResult> {
    return this.apiKpIsCreateKpiPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateKpiCommandResult>): CreateKpiCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpIsCreateKpIsFromExcelSheetPost()` */
  static readonly ApiKpIsCreateKpIsFromExcelSheetPostPath = '/api/KPIs/CreateKPIsFromExcelSheet';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsCreateKpIsFromExcelSheetPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpIsCreateKpIsFromExcelSheetPost$Plain$Response(params?: ApiKpIsCreateKpIsFromExcelSheetPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateKpIsFromExcelSheetResult>> {
    return apiKpIsCreateKpIsFromExcelSheetPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsCreateKpIsFromExcelSheetPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpIsCreateKpIsFromExcelSheetPost$Plain(params?: ApiKpIsCreateKpIsFromExcelSheetPost$Plain$Params, context?: HttpContext): Observable<CreateKpIsFromExcelSheetResult> {
    return this.apiKpIsCreateKpIsFromExcelSheetPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateKpIsFromExcelSheetResult>): CreateKpIsFromExcelSheetResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsCreateKpIsFromExcelSheetPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpIsCreateKpIsFromExcelSheetPost$Response(params?: ApiKpIsCreateKpIsFromExcelSheetPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateKpIsFromExcelSheetResult>> {
    return apiKpIsCreateKpIsFromExcelSheetPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsCreateKpIsFromExcelSheetPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiKpIsCreateKpIsFromExcelSheetPost(params?: ApiKpIsCreateKpIsFromExcelSheetPost$Params, context?: HttpContext): Observable<CreateKpIsFromExcelSheetResult> {
    return this.apiKpIsCreateKpIsFromExcelSheetPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateKpIsFromExcelSheetResult>): CreateKpIsFromExcelSheetResult => r.body)
    );
  }

  /** Path part for operation `apiKpIsUpdateKpiPut()` */
  static readonly ApiKpIsUpdateKpiPutPath = '/api/KPIs/UpdateKpi';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsUpdateKpiPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsUpdateKpiPut$Plain$Response(params?: ApiKpIsUpdateKpiPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiKpIsUpdateKpiPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsUpdateKpiPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsUpdateKpiPut$Plain(params?: ApiKpIsUpdateKpiPut$Plain$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiKpIsUpdateKpiPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsUpdateKpiPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsUpdateKpiPut$Response(params?: ApiKpIsUpdateKpiPut$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiKpIsUpdateKpiPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsUpdateKpiPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsUpdateKpiPut(params?: ApiKpIsUpdateKpiPut$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiKpIsUpdateKpiPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpIsAddOptionPost()` */
  static readonly ApiKpIsAddOptionPostPath = '/api/KPIs/AddOption';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsAddOptionPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsAddOptionPost$Plain$Response(params?: ApiKpIsAddOptionPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AddOptionCommandResult>> {
    return apiKpIsAddOptionPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsAddOptionPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsAddOptionPost$Plain(params?: ApiKpIsAddOptionPost$Plain$Params, context?: HttpContext): Observable<AddOptionCommandResult> {
    return this.apiKpIsAddOptionPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddOptionCommandResult>): AddOptionCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsAddOptionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsAddOptionPost$Response(params?: ApiKpIsAddOptionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AddOptionCommandResult>> {
    return apiKpIsAddOptionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsAddOptionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsAddOptionPost(params?: ApiKpIsAddOptionPost$Params, context?: HttpContext): Observable<AddOptionCommandResult> {
    return this.apiKpIsAddOptionPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AddOptionCommandResult>): AddOptionCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpIsDeleteOptionDelete()` */
  static readonly ApiKpIsDeleteOptionDeletePath = '/api/KPIs/DeleteOption';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsDeleteOptionDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteOptionDelete$Plain$Response(params?: ApiKpIsDeleteOptionDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOptionCommandResult>> {
    return apiKpIsDeleteOptionDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsDeleteOptionDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteOptionDelete$Plain(params?: ApiKpIsDeleteOptionDelete$Plain$Params, context?: HttpContext): Observable<DeleteOptionCommandResult> {
    return this.apiKpIsDeleteOptionDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOptionCommandResult>): DeleteOptionCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsDeleteOptionDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteOptionDelete$Response(params?: ApiKpIsDeleteOptionDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOptionCommandResult>> {
    return apiKpIsDeleteOptionDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsDeleteOptionDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteOptionDelete(params?: ApiKpIsDeleteOptionDelete$Params, context?: HttpContext): Observable<DeleteOptionCommandResult> {
    return this.apiKpIsDeleteOptionDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<DeleteOptionCommandResult>): DeleteOptionCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpIsDeleteKpiDelete()` */
  static readonly ApiKpIsDeleteKpiDeletePath = '/api/KPIs/DeleteKPI';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsDeleteKpiDelete$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteKpiDelete$Plain$Response(params?: ApiKpIsDeleteKpiDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiKpIsDeleteKpiDelete$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsDeleteKpiDelete$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteKpiDelete$Plain(params?: ApiKpIsDeleteKpiDelete$Plain$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiKpIsDeleteKpiDelete$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsDeleteKpiDelete()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteKpiDelete$Response(params?: ApiKpIsDeleteKpiDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseCommandResult>> {
    return apiKpIsDeleteKpiDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsDeleteKpiDelete$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsDeleteKpiDelete(params?: ApiKpIsDeleteKpiDelete$Params, context?: HttpContext): Observable<BaseCommandResult> {
    return this.apiKpIsDeleteKpiDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<BaseCommandResult>): BaseCommandResult => r.body)
    );
  }

  /** Path part for operation `apiKpIsGetKpIsPost()` */
  static readonly ApiKpIsGetKpIsPostPath = '/api/KPIs/GetKPIs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsGetKpIsPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsGetKpIsPost$Plain$Response(params?: ApiKpIsGetKpIsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetKpIsQueryResult>> {
    return apiKpIsGetKpIsPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsGetKpIsPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsGetKpIsPost$Plain(params?: ApiKpIsGetKpIsPost$Plain$Params, context?: HttpContext): Observable<GetKpIsQueryResult> {
    return this.apiKpIsGetKpIsPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetKpIsQueryResult>): GetKpIsQueryResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiKpIsGetKpIsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsGetKpIsPost$Response(params?: ApiKpIsGetKpIsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetKpIsQueryResult>> {
    return apiKpIsGetKpIsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiKpIsGetKpIsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiKpIsGetKpIsPost(params?: ApiKpIsGetKpIsPost$Params, context?: HttpContext): Observable<GetKpIsQueryResult> {
    return this.apiKpIsGetKpIsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetKpIsQueryResult>): GetKpIsQueryResult => r.body)
    );
  }

}
